import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { DEFAULT_PAGE_SIZE, urlEndPoint } from "helpers/GeneralHelper";

import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from "reactstrap";
import AchievementCustomTable from "components/Common/AchievementCustomTable";
import { submitIncentiveMonthlyThreeFilterData } from "model/IncentiveMonthlyModel";

const AchievementsThree = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [achievementData, setAchievementData] = useState([]);
    const columns = [
        { Header: "Client", accessor: "client" },
        { Header: "Target", accessor: "target" },
        { Header: "Rs/Per", accessor: "rs" },
        { Header: "Negative", accessor: "negative" },
        { Header: "Achieve", accessor: "achieve" },
        { Header: "WorkDays", accessor: "workdays" },
        { Header: "Count", accessor: "count" },
        { Header: "Incentive", accessor: "incentive" },
    ];

    // Filtering
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return achievementData;

        return achievementData.filter((team) =>
            team.members.some((member) =>
                member.rows.some((row) =>
                    Object.values(row)
                        .some((val) =>
                            String(val).toLowerCase().includes(searchQuery.toLowerCase())
                        )
                )
            )
        );
    }, [searchQuery, achievementData]);

    const redirectToCurrentMonthDetails = async () => {
        const response = await submitIncentiveMonthlyThreeFilterData({
            pageNumber: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            status: "active",
        });
        const responseData = response?.data || {};
        const records = Array.isArray(responseData?.records)
            ? responseData?.records
            : Array.isArray(responseData)
                ? responseData
                : [];

        const currentMonthRecord = records.find((item) =>
            dayjs(item?.monthDate).isValid() && dayjs(item?.monthDate).isSame(dayjs(), "month")
        );
        if (currentMonthRecord?.id) {
            navigate(`/${urlEndPoint.monthlyDetailsThree}/${currentMonthRecord.id}`);
        }
    };

    useEffect(() => {
        redirectToCurrentMonthDetails();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <Row className="align-items-center g-2">

                                <Col xs="12" md="12" className="text-md-start text-center">
                                    <h5 className="fw-bold mb-0">Incentive Details</h5>
                                    <hr />
                                </Col>
                            </Row>
                            <div className="mt-2">

                                {/* <AchievementCustomTable
                                    columns={columns}
                                    data={filteredData}   
                                    isActionRequired={false}
                                /> */}
                            </div>
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </React.Fragment>
    );
};

AchievementsThree.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(AchievementsThree);
